module.exports = __webpack_public_path__ + "img/thumbnail_Addax_j_normal.23ad601f.png";